import React, { FC } from 'react'
import { Grid, Button, Typography, Slide, useTheme, useMediaQuery } from '@material-ui/core'
import useTopToastNotification from '@hooks/useTopToastNotification'
import RenderIf from '@components/RenderIf'
import ReactTyped from 'react-typed'
import useStyles from '../styles'
import { SCRIPT_GENERATOR_METHOD, scritpGeneratorScriptContentCopiedTrack } from '@components/SegmentTrackers'
import SVGCopyClipboard from '@assets/SVGCopyClipboard2'
import LoadingScript from '@components/VideoScriptGenerator/LoadingScript'
import { copyToClipboard } from '@utils/index'

interface IScriptPanelProps {
  id: string;
  currentTab: string;
  content?: string;
}

const ScriptPanel: FC<IScriptPanelProps> = ({ id, currentTab, content = '' }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { notification } = useTopToastNotification()

  const handleCopyToClipboardScript = async () => {
    scritpGeneratorScriptContentCopiedTrack(SCRIPT_GENERATOR_METHOD.SCRIPT_GENERATOR_SCRIPT_COPYCONTENT, { content: 'video script' })
    copyToClipboard(content || '', true, notification)
  }

  return (
    <Slide direction="right" in={id === currentTab}>
      <Grid container style={{ display: id === currentTab ? 'block' : 'none', height: '100%' }}>
        <RenderIf condition={content !== ''}>
          <>
            <ReactTyped
              className={classes.typedSpan}
              strings={[content?.replace(/^\s+|\s+$/g, '') || '']}
              typeSpeed={20}
              cursorChar="▋"
            />
            <Grid container className={classes.actionButtonsContainer}>
              <Button
                variant="outlined"
                className={classes.actionButton}
                onClick={handleCopyToClipboardScript}
              >
                <SVGCopyClipboard color="#6140FF" />
                <RenderIf condition={isMobile}>
                  <Typography component="span">
                    Copy
                  </Typography>
                </RenderIf>
              </Button>
            </Grid>
          </>
        </RenderIf>
        <RenderIf condition={content === ''}>
          <LoadingScript />
        </RenderIf>
      </Grid>
    </Slide>
  )
}

export default ScriptPanel
